import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you're looking for could not be found." />
      <h1>Page not found</h1>
      <p>Sorry, we couldn&rsquo;t find the page you&rsquo;re looking for.</p>
      <Link className="btn btn-primary" to="/">
        Back to home
      </Link>
    </>
  );
}
